import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Questionario } from '../../app/models/ConcessionariaModel';
import { HttpProvider } from "../http/http";

@Injectable()
export class relatorioProvider {


  constructor(private httpSrv: HttpProvider) {


  }
  
    /**
    * * Função async que salva o log de busca placa.
    * @example salvaRelatorioBuscaPlaca(234, 12, 'GFY-5434', {...any})
    * @param {number} idLoja number
    * @param {number} idUsuario number 
    * @param {string} placa string
    * @param {any} retornoBuscaPlaca any 
    * @return {void} void.
    */
  async salvaRelatorioBuscaPlaca(idLoja: number, idUsuario: any, placa: string,retornoBuscaPlaca: any):Promise<void> {
    try{

      console.log('mandou relatorio')

      const response = await this.httpSrv.postApi('v1/salvaRelatorioBuscaPlaca', { idLoja, idUsuario, placa, retornoBuscaPlaca }, 0);
      console.log(`response: ${response}`)


    } catch(e){
        console.log(`ocorreu um erro ao salvar log de busca placa: ${e}`);
    }
  }
  
  async salvaQuestionarioSaida(object:any) {
    try{

      console.log('mandou questionario')

      const response = await this.httpSrv.postApi('v1/salvaQuestionarioSaida', object, 0);
      console.log(`response: ${response}`)


    } catch(e){
        console.log(`ocorreu um erro ao salvar log de busca placa: ${e}`);
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/relatorio/relatorio.ts